export function Jobibot({ size = 74 }: { size?: number }) {
	return (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 75 74">
				<defs>
					<linearGradient id="a" x1="-.007%" x2="100.015%" y1="49.987%" y2="49.987%">
						<stop offset="0%" stopColor="#304FFB" />
						<stop offset="100%" stopColor="#39D0FD" />
					</linearGradient>
					<linearGradient id="b" x1=".004%" x2="100%" y1="50%" y2="50%">
						<stop offset="0%" stopColor="#710DE0" />
						<stop offset="100%" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="c" x1="-.006%" x2="100.003%" y1="49.999%" y2="49.999%">
						<stop offset="0%" stopColor="#710DE0" />
						<stop offset="100%" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="d" x1="10.929%" x2="62.491%" y1="72.18%" y2="15.615%">
						<stop offset="0%" stopColor="#710DE0" />
						<stop offset="100%" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="e" x1="14.645%" x2="85.377%" y1="85.394%" y2="14.662%">
						<stop offset="0%" stopColor="#710DE0" />
						<stop offset="100%" stopColor="#304FFB" />
					</linearGradient>
					<linearGradient id="f" x1=".046%" x2="99.999%" y1="50.028%" y2="50.028%">
						<stop offset="0%" stopColor="#304FFB" />
						<stop offset="100%" stopColor="#1028AE" />
					</linearGradient>
					<linearGradient id="g" x1="99.978%" x2=".024%" y1="49.998%" y2="49.998%">
						<stop offset="0%" stopColor="#304FFB" />
						<stop offset="100%" stopColor="#1028AE" />
					</linearGradient>
				</defs>
				<g fill="none" fillRule="nonzero" className="jobibot">
					<path
						fill="#FFF"
						d="M67 25.317c0-.008 0-.008 0 0a6.288 6.288 0 0 0-1.28-3.778c-1.075-1.459-2.779-2.486-4.944-2.539h-46.4A6.377 6.377 0 0 0 8 25.377v33.306c.015 1.466.5 2.75 1.28 3.778 1.075 1.459 2.779 2.486 4.944 2.539h46.4A6.377 6.377 0 0 0 67 58.623V25.317Z"
					/>
					<g className="antenna">
						<path
							fill="transparent"
							d="M67 25.317c0-.008 0-.008 0 0a6.288 6.288 0 0 0-1.28-3.778c-1.075-1.459-2.779-2.486-4.944-2.539h-46.4A6.377 6.377 0 0 0 8 25.377v33.306c.015 1.466.5 2.75 1.28 3.778 1.075 1.459 2.779 2.486 4.944 2.539h46.4A6.377 6.377 0 0 0 67 58.623V25.317Z"
						/>
						<path fill="#304FFB" d="M35 5h5v10h-5z" />
						<circle cx="38" cy="6" r="6" fill="url(#e)" />
					</g>
					<path
						fill="url(#a)"
						d="M48.887 15H26.113C23.843 15 22 16.792 22 19s1.843 4 4.113 4h22.774C51.157 23 53 21.208 53 19c.007-2.208-1.835-4-4.113-4Z"
					/>
					<path
						fill="url(#b)"
						d="M8 58.61V25.383A6.383 6.383 0 0 1 14.38 19h46.23c6.199 0 8.75 7.946 3.724 11.564l-46.23 33.228C13.881 66.82 8 63.807 8 58.61Z"
					/>
					<path
						fill="url(#c)"
						d="M67 25.39v33.227A6.383 6.383 0 0 1 60.619 65H14.39c-6.2 0-8.75-7.946-3.725-11.564l46.236-33.228C61.118 17.18 67 20.193 67 25.39Z"
						opacity=".82"
					/>
					<path fill="url(#d)" d="M57 65H43v7.706c0 1.056 1.185 1.662 2.032 1.049L57 65Z" />
					<g transform="translate(35 28)">
						<ellipse cx="14.386" cy="14.5" fill="#07C4FC" rx="14.386" ry="14.5" />
						<ellipse cx="14.386" cy="14.652" fill="#FFF" rx="9.787" ry="9.895" />
						<g className="eye-container">
							<ellipse cx="14.386" cy="14.652" fill="url(#f)" className="eyes" rx="5.369" ry="5.411" />
						</g>
					</g>
					<path
						fill="#07C4FC"
						d="M68.418 36.025h-6.236a14.413 14.413 0 0 1 1.613 6.635c0 2.394-.58 4.65-1.613 6.634h6.236c3.619 0 6.582-2.987 6.582-6.634 0-3.656-2.963-6.635-6.582-6.635Z"
					/>
					<path
						fill="#39D0FD"
						d="M68.387 49.286c3.635 0 6.605-2.986 6.605-6.634s-2.97-6.634-6.605-6.634h-1.704v13.268h1.704Z"
					/>
					<path
						fill="#6ADCFD"
						d="M63.795 42.652c0-2.394-.58-4.65-1.613-6.634h-5.535a9.926 9.926 0 0 1 2.526 6.634 9.926 9.926 0 0 1-2.526 6.634h5.535a14.32 14.32 0 0 0 1.613-6.634Z"
					/>
					<g transform="translate(11.227 28)">
						<ellipse cx="14.386" cy="14.5" fill="#07C4FC" rx="14.386" ry="14.5" />
						<ellipse cx="14.386" cy="14.5" fill="#FFF" rx="9.787" ry="9.895" />
						<g className="eye-container">
							<ellipse cx="14.386" cy="14.5" fill="url(#g)" className="eyes" rx="5.369" ry="5.411" />
						</g>
					</g>
					<path
						fill="#07C4FC"
						d="M6.582 35.866h6.236a14.413 14.413 0 0 0-1.613 6.634c0 2.394.58 4.651 1.613 6.634H6.582C2.963 49.134 0 46.148 0 42.5s2.963-6.634 6.582-6.634Z"
					/>
					<path
						fill="#39D0FD"
						d="M6.613 49.134c-3.635 0-6.605-2.986-6.605-6.634s2.97-6.634 6.605-6.634h1.704v13.268H6.613Z"
					/>
					<path
						fill="#6ADCFD"
						d="M11.205 42.5c0-2.394.58-4.65 1.613-6.634h5.534a9.926 9.926 0 0 0-2.525 6.634c0 2.553.957 4.879 2.525 6.634h-5.534a14.437 14.437 0 0 1-1.613-6.634Z"
					/>
				</g>
			</svg>
		</>
	)
}
